import './Loader.scss';

const Loader = () => {
    return (
        <div className="overlay ">
            <div className="spin center">
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
            </div>
        </div>
    );
};

export default Loader;
